import { CompanyResult, DetailedPotentialResult } from "models/StatisticsReport";
import LineChart from "../Charts/LineChart";
import generateBackgroundColors from "utility/generateBackgroundColors";

interface PotentialProps {
    data: DetailedPotentialResult;
    company: CompanyResult;
}

const Potential = ({data, company}:PotentialProps) => {
    const chartLabels = data.companyData.map((element) => element.name);
    const {baseColorsFormatted} = generateBackgroundColors();
    const chartSet = [
        {
            label: company.name,
            data: data.companyData.map((element) => element.count),
            backgroundColor: baseColorsFormatted[0],
            borderColor: baseColorsFormatted[0]
        },
        {
            label: "Ikke annonsør",
            data: data.nonCustomersData.map((element) => element.count),
            backgroundColor: baseColorsFormatted[1],
            borderColor: baseColorsFormatted[1]
        },
        {
            label: "Annonsør",
            data: data.customersData.map((element) => element.count),
            backgroundColor: baseColorsFormatted[2],
            borderColor: baseColorsFormatted[2]
        }
    ]

    return (
        <div className="card mb-4">
            <div className="card-header">
                <h2>Antall klikk sammenlignet med andre bedrifter</h2>
            </div>
            <div className="card-body">
                <LineChart labels={chartLabels} datasets={chartSet} />
                <p className="mb-0 text-muted"><small>Bransje: {data.businessArea} i {data.tradeArea}</small></p>
            </div>
        </div>
    );
}

export default Potential;